import Shell from "./Shell";
export default Shell;

console.log(`
#######                                        
     #  ######  ####  ##### #   #     #  ####  
    #   #      #        #    # #      # #    # 
   #    #####   ####    #     #       # #    # 
  #     #           #   #     #   ### # #    # 
 #      #      #    #   #     #   ### # #    # 
####### ######  ####    #     #   ### #  #### 

Hello there from the Zesty.io team.
If you are looking to understand how this application is built or need to submit a bug report 
visit our public repository: https://github.com/zesty-io/manager-ui
`);
